import type {ContextMenuItem} from './types';

export const getAdditionalEntryContextMenuItems = (): ContextMenuItem[] => {
    return [];
};
